"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWheelSizeStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useWheelSizeStore = (0, pinia_1.defineStore)("wheelSizeStore", {
    state: () => ({
        carBrands: [],
        carYears: [],
        carModels: [],
        carDetails: [],
    }),
    getters: {},
    actions: {
        /*async getCarBrands() {
      const response = await fetch(`https://auto.bhpgumi.hu/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          api_key: apiKey,
          action: "getGyartok",
        }),
      });

      const datas = await response.json();

      datas.forEach((item: CarBrandsInterface) => {
        this.carBrands.push(item);
      });
      //this.carBrands.push(data);
    },*/
        async getCarBrands() {
            const response = await (0, fetch_1.default)(`/api/wheelsize/get/carbrands`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
            });
            const datas = await response;
            datas.forEach((item) => {
                this.carBrands.push(item);
            });
            //this.carBrands.push(data);
        },
        async getCarModells(gyarto_slug) {
            this.carModels = [];
            const response = await (0, fetch_1.default)(`/api/wheelsize/get/carmodels`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    gyarto: gyarto_slug,
                }),
            });
            const datas = await response;
            datas.forEach((item) => {
                const { name, slug } = item;
                this.carModels.push({ name, slug });
            });
        },
        async getCarYears(gyarto_slug, modell_slug) {
            this.carYears = [];
            const response = await (0, fetch_1.default)(`/api/wheelsize/get/caryears`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    gyarto: gyarto_slug,
                    model: modell_slug,
                }),
            });
            const datas = await response;
            datas.forEach((item) => {
                const { name, slug } = item;
                this.carYears.push({ name, slug });
            });
        },
        async getCarDetails(gyarto_slug, gyartasi_ev, modell) {
            this.carDetails = [];
            const response = await (0, fetch_1.default)(`/api/wheelsize/get/cardetails`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    gyarto: gyarto_slug,
                    gyartasi_ev: gyartasi_ev,
                    model: modell,
                }),
            });
            const datas = await response;
            //console.log(datas);
            let diameters = new Set(); // A Set adatszerkezet elemeket tárol, mint a tömb, de minden elem csak egyszer szerepelhet benne.
            datas.forEach((item) => {
                diameters.clear();
                Object.values(item["wheels"]).forEach((wheel) => {
                    diameters.add(wheel);
                });
                // +1/-1 diameter hozzáadása az abrocs méretekhez
                //let min: number = Math.min(...diameters);
                let max = Math.max(...diameters);
                //diameters.add(min - 1);
                diameters.add(max + 1);
                this.carDetails.push({
                    name: item.name,
                    slug: item.slug,
                    horsepower: item.horsepower,
                    kilowatt: item.kilowatt,
                    wheels: Array.from(diameters).sort((a, b) => a - b), // tömb kinyerése és sorba rendezése (növekvő)
                });
            });
        },
    },
});
